module.exports = __webpack_public_path__ + "img/top-photo.37e13b88.png";